<template>
    <div id="frame-general" class="container-frame">
        <h1 id="frame-title">Général</h1>
        <div id="container-general">
            <!--COLONE 1-->
            <div class="general-sous-menu" id="general-enregistrement">
                <h2>Enregistrement</h2>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Confirmer si montants différents</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Confirmer toujours la Feuille de soins</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Abandon du patient après enregistrement</label>
                </div>
            </div>
            <!--COLONE 2-->
            <div class="general-sous-menu" id="general-reçu">
                <h2>Reçu</h2>
                <div class="general-group">
                    <input type="radio" name="reçu" /><label>Editer toujours sur traitement texte</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="reçu" /><label>Demander pour édition</label>
                    <input type="radio" name="reçu" /><label>Ne jamais éditer</label>
                </div>
                <div id="general-traitement-de-texte">
                    <h2>Traitement de texte</h2>
                    <div class="general-group">
                        <input type="radio" name="traitementDeTexte" /><label>Utiliser Fisipad</label>
                        <input type="radio" name="traitementDeTexte" /><label>Utiliser le traitement de texte de la machine</label>
                    </div>
                </div>
            </div>
            <div class="general-sous-menu">
                <h2>Couleurs</h2>
                <div class="general-group">
                    <input type="color" name="couleurBordure" /><label>Couleur bordure</label>
                    <input type="color" name="couleurFond" /><label>Couleur fond</label>
                    <input type="color" name="couleurFondlibelles" /><label>Couleur fond libellés</label>
                </div>
                <div class="btn-group" id="coloration">
                    <button>Couleurs par défaut</button>
                </div>
            </div>
            <div class="general-sous-menu">
                <h2>Tiers payant par défaut</h2>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Tiers payant AMO</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Tiers payant Comp./Mut</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Avec DRE</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Pour les invalidités</label>
                </div>
            </div>
            <div class="general-sous-menu">
                <h2>Gestion TP ASCS par défaut</h2>
                <div class="general-group">
                    <input type="radio" name="GTP_ACS_par_defaut" />
                    <label>En gestion AMC avec Contrat</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="GTP_ACS_par_defaut" />
                    <label>En TP Coordonné AMO (TOPM)</label>
                </div>
            </div>
            <div id="general-container-btn-selection-par-defaut">
                <div class="btn-group">
                    <button>Paramétrage des sélections par défaut</button>
                </div>
            </div>
        </div>
        <div id="frame-footer">
            <button @click="annuler()">Annuler</button>
            <button @click="appliquer()">Appliquer</button>
        </div>
    </div>
</template>

<style scoped>
    @import "./parametre.css";       
</style>


<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {
            //Les composants
        },
        data: function () {
            return {
                message: 'Parametre Général'
            }
        },

        computed: {

        },

        methods: {

        },

        props: {

        },
        mounted() {

        }

        ,
        created() {

        }

    });
</script>
